import { listaDeInformes } from "@/Routes/listaDeInformes";
import { Alert } from "@mui/material";
import { showNotification } from "../redux/features/notificationSlice"; // + Import showNotification
import { store } from "../redux/store"; // + Import store

export const copyStringToClipboard = (text: string) => {
  navigator.clipboard.writeText(String(text).toUpperCase())
    .catch(error => {
      console.error('Error copying text to clipboard:', error);
    });
};


export function formatToCurrencyARS(value: number): string {
  const formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS', // Código ISO de la moneda argentina
    minimumFractionDigits: 0, // Establecer el número mínimo de decimales
    maximumFractionDigits: 2, // Establecer el número máximo de decimales
  });

  return formatter.format(value);
}

export function esUnNumero(valor: any) {
  return typeof valor !== 'number' || isNaN(valor)
}

export function esEmail(email: string) {
  const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return regex.test(email);
}

export function removeNaNValues(obj: { [key: string]: any }) {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      // If the property is an object (but not an array), recursively call the function
      removeNaNValues(obj[key]);
    } else if (typeof obj[key] === 'number' && isNaN(obj[key])) {
      // If the property is a number and is NaN, delete it
      delete obj[key];
    }
  }
}

export const isEmptyObject = (obj: any) => {
  return Object.keys(obj).length === 0;
}


export const ObtenerInformesPorSubdivision = (informes: typeof listaDeInformes) => {
  const informesPorSubdivision: { [key: string]: any } = {};
  for (const informe of informes) {
    const { subdivision } = informe;
    if (!subdivision) continue;
    if (!informesPorSubdivision[subdivision]) {
      informesPorSubdivision[subdivision] = [];
    }
    informesPorSubdivision[subdivision].push(informe);
  }
  return informesPorSubdivision;
};

export function isOnlyLetters(value: string) {
  return /^[A-Za-z]+$/.test(value);
}



export const convertBase64ToFile = (base64String: string, fileName: string) => {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

export function obtenerAtributoAnidado(objeto: any, propiedades: any) {
  //@ts-ignore
  return propiedades.reduce((acumulador, propiedad) => (acumulador ? acumulador[propiedad] : undefined), objeto);
}


export const getFileNameFromLink = (fileLink: string) => {
  const url = new URL(fileLink || '');
  const nombreArchivo = url.searchParams.get('nombreArchivo');
  return nombreArchivo || 'nombre_del_archivo.pdf'; // Si no se encuentra el parámetro, usa un nombre predeterminado
}

export const getFileRenamedFromLink = (fileLink: string) => {
  const url = new URL(fileLink);
  let nombreArchivo = url?.searchParams?.get('nombreArchivo') || undefined;
  try {
    if (nombreArchivo) {
      nombreArchivo = nombreArchivo.replace(/ /g, '_'); // Reemplaza los espacios en blanco por guiones bajos
      const partes = nombreArchivo.split('_');
      if (partes.length > 1) {
        const extension = partes[partes.length - 1].split('.')[1];
        nombreArchivo = `${partes.slice(0, -1).join('_')}.${extension}`;
      }
    }
  }
  catch (error) {
    console.error('Error al renombrar el archivo:', error);
  }

  return nombreArchivo || 'nombre_del_archivo.pdf'; // Si no se encuentra el parámetro, usa un nombre predeterminado
}


export const getFileRenamed = (fileName: string) => {
  let nombreArchivo = fileName;

  if (nombreArchivo) {
    nombreArchivo = nombreArchivo.replace(/ /g, '_'); // Reemplaza los espacios en blanco por guiones bajos
    const partes = nombreArchivo.split('_');
    if (partes.length > 1) {
      const extension = partes[partes.length - 1].split('.')[1];
      nombreArchivo = `${partes.slice(0, -1).join('_')}.${extension}`;
    }
  }

  return nombreArchivo || 'nombre_del_archivo.pdf'; // Si no se encuentra el parámetro, usa un nombre predeterminado
}



export const downloadAndRenameFile = (fileLink: string, fileName: string) => {

  fetch(fileLink)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobUrl;
      a.download = fileName;

      document.body.appendChild(a);

      a.click();

      URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error('Error al descargar el archivo:', error);
    });
}

